<template>
  <div class="ds-control mobile dsf_teas_attendance_detail">
    <div class="search">
      <van-search v-model="keywords" shape="round" @input="search" placeholder="请输入关键词" />
    </div>
    <div class="statistics">
      <div class="statistics-item">
        <div :class="!resultValue?'chooseVal':''" @click="chooseChange('')">
          <p class="num">{{ totalObj.should }}</p>
          <p class="name">应到</p>
        </div>
      </div>
      <div class="statistics-item">
        <div :class="resultValue=='1'?'chooseVal':''" @click="chooseChange('1')">
          <p class="num">{{ totalObj.onTime }}</p>
          <p class="name">出勤</p>
        </div>
      </div>
      <div class="statistics-item">
        <div :class="resultValue=='2'?'chooseVal':''" @click="chooseChange('2')">
          <p class="num">{{ totalObj.late }}</p>
          <p class="name">迟到</p>
        </div>
      </div>
      <div class="statistics-item">
        <div :class="resultValue=='9'?'chooseVal':''" @click="chooseChange('9')">
          <p class="num">{{ totalObj.notSign }}</p>
          <p class="name">未签</p>
        </div>
      </div>
    </div>
    <div class="list" v-if="list.length > 0">
      <van-pull-refresh v-model="refreshing" @refresh="onRefresh" style="min-height:60vh;">
        <van-list v-model="loading" :finished="finished" finished-text="没有更多了" :error.sync="error" @load="getList">
          <!-- <div class="list-item" v-for="(item, index) in list" :key="index">
            <div class="cell name">{{ item.expertName }}</div>
            <div class="cell phone">{{ item.phone }}</div>
            <div
              class="status"
              :class="{
                chuqin: item.resultValue === '1',
                gongjia: item.resultValue === '2',
                weiqian: item.resultValue === '9',
              }"
              @click="changeStatus(item)"
            >
              {{ item.resultText }}
            </div>
          </div> -->
          <DsfMobileTeasCell class="list-item" border v-for="(item, index) in list" :key="index" :title="item.expertName">
            <DsfMobileTeasCellItem label="" :value="item.phone"></DsfMobileTeasCellItem>
            <div slot="ft" class="status" :class="{chuqin: item.resultValue === '1',gongjia: item.resultValue === '2',weiqian: item.resultValue === '9',}" @click="changeStatus(item)"> {{ item.resultText }}</div>
          </DsfMobileTeasCell>
        </van-list>
      </van-pull-refresh>
    </div>
    <van-empty v-else description="暂无数据" />
    <van-popup v-model="showStatus" round position="bottom">
      <van-picker show-toolbar :columns="statusOption" @cancel="showStatus = false" @confirm="onConfirm" />
    </van-popup>
  </div>
</template>

<script>
export default dsf.component({
  name: "DsfMobileTeasSignInDetailList",
  mixins: [$mixins.control],
  ctrlCaption: "签到详情",
  design: {
    isMask: false,
  },
  props: {
    // 列表接口
    sourcesUrl: {
      type: String,
      default: "/teas/attendance/lecture/queryLectureAttendDetail",
    },
    // 手动更新状态接口
    updateStatusUrl: {
      type: String,
      default: "/teas/attendance/lecture/batchUpdLectureAttendStatus",
    },
  },
  data() {
    return {
      loading: false,
      finished: false,
      refreshing: false,
      error: false,
      isCanChangeStatus: false, // 是否可以更改状态
      keywords: "",
      pageNum: 0,
      list: [],
      totalObj: {
        late: 0,
        notSign: 0,
        should: 0,
        onTime: 0,
      },
      // 更改状态的用户id
      changeObject: {},
      showStatus: false,
      statusOption: [],
      resultValue: ''
    };
  },
  created() {
    if (this.isDesign) {
      this.list = [];
    } else {
      this.lectureId = this.$route.query.lectureId;
      this.getList();
      this.getStatusOption();
    }
  },
  methods: {
    search: _.debounce(function () {
      this.onRefresh();
    }, 300),
    chooseChange(val) {
      if (this.$listeners["change"]) {
        this.$dispatch("change", { val });
      } else {
        if (this.resultValue !== val) {
          this.resultValue = val;
          this.getList()
        }
      }
    },
    // 获取列表数据
    getList() {
      const loading = dsf.layer.loading();
      this.$http
        .get(this.$replace(this.sourcesUrl), {
          lectureId: this.lectureId,
          search: this.keywords,
          screenStatus: this.resultValue
        })
        .done((res) => {
          this.finished = true;
          if (res.success && res.state == 20000 && res.data) {
            this.list = res.data.expert;
            this.$delete(res.data, "expert");
            this.totalObj = res.data;
          } else {
            dsf.layer.message(res.message, false);
            this.error = true;
          }
        })
        .error((err) => {
          dsf.layer.message(err.message || "出错了，请重试", false);
          this.error = true;
        })
        .always(() => {
          this.loading = false;
          this.finished = true;
          this.refreshing = false;
          dsf.layer.closeLoading(loading);
        });
    },
    // 刷新
    onRefresh() {
      this.getList();
    },
    // 获取状态列表
    getStatusOption() {
      this.isCanChangeStatus = true;
      this.statusOption = [
        {
          text: "出勤",
          value: "1",
        },
        {
          text: "迟到",
          value: "2",
        },
        {
          text: "未签",
          value: "9",
        },
      ];
    },
    // 更新出勤状态
    changeStatus(item) {
      if (this.isCanChangeStatus) {
        this.changeObject = item;
        this.showStatus = true;
      }
    },
    // 确定修改状态
    onConfirm(select) {
      this.showStatus = false;
      const loading = dsf.layer.loading();
      this.$http
        .post(
          this.$replace(this.updateStatusUrl),
          {
            relId: this.lectureId,
            resultText: select.text,
            resultValue: select.value,
            expert: [
              {
                text: this.changeObject.expertName || "",
                value: this.changeObject.expertId || "",
              },
            ],
          },
          {
            headers: {
              "Content-Type": "application/json;charset=UTF-8",
            },
          }
        )
        .done((res) => {
          if (res.success && res.state == 20000 && res.data) {
            dsf.layer.message("操作成功！", true);
            this.onRefresh();
          } else {
            dsf.layer.message(res.message, false);
            this.error = true;
          }
        })
        .error((err) => {
          dsf.layer.message(err.message || "出错了，请重试", false);
          this.error = true;
        })
        .always(() => {
          dsf.layer.closeLoading(loading);
        });
    },
  },
});
</script>
